import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error) {
    // Update state so the next render will show the fallback UI.
    console.log(_error.message);
    return { hasError: true };
  }

  componentDidCatch(_error, _errorInfo) {
    // You can also log the error to an error reporting service
    console.log(_errorInfo);
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <h1>Something went wrong.</h1>;
    }

    return this.props.children;
  }
}